import { Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import Iconify from "minimals-template/components/Iconify"
import { COLOR_FROM_CLASSIFICATION, ICON_FROM_CLASSIFICATION } from "library/SFG20/constants.mjs"
import { describeTaskTiming } from "./describe-task-details"
import { ScheduleTaskSkillBadge } from "./schedule-task-skill-badge"

/**
 * Criticality, frequency, duration and skill for one task, so a user can decide task by
 * task which trade it should go to.
 */
export function ScheduleTaskDetails({ task }) {
    const timing = describeTaskTiming(task)

    return (
        <Stack direction="row" alignItems="center" spacing={0.75} sx={{ minWidth: 0 }} data-cy="schedule-task-details">
            <If value={!!task.classification}>
                <Iconify
                    icon={ICON_FROM_CLASSIFICATION[task.classification]}
                    width={14}
                    sx={{ color: COLOR_FROM_CLASSIFICATION[task.classification], flexShrink: 0 }}
                    aria-label={`Criticality: ${task.classification}`}
                />
            </If>
            <Typography variant="caption" color="text.secondary" noWrap sx={{ flexShrink: 0 }}>
                {timing}
            </Typography>
            <If value={!!task.skillCode}>
                <ScheduleTaskSkillBadge skillName={task.skillName} skillCode={task.skillCode} />
            </If>
        </Stack>
    )
}
